import { useWindowSize } from 'react-use';
import Link from 'next/link';

import { useFeatureFlag } from '@/hooks/featureFlag/useFeatureFlag';

import useToggle from '@/utils/hooks/utils/useToggle';

import Icon from '@/components/base/Icon';
import Iconosquare from '@/components/icons/Iconosquare';
import IconosquareChristmas from '@/components/icons/IconosquareChristmas';
import { SideBar } from '@/components/layouts/LayoutPlatform/components/Menu/MenuMobile/Sidebar';

export function MenuMobile() {
    const { isOpen, toggle } = useToggle();
    const { width } = useWindowSize();
    const showChristmasPromotion = useFeatureFlag('christmas_promotion');

    if (isOpen && width > 639) {
        toggle();
    }

    return (
        <div className="mr-3 flex items-center gap-3 sm:hidden">
            <button
                onClick={toggle}
                data-testid="button-toggle-social-inbox-mobile-menu"
                className="flex items-center text-icoGray-500 dark:text-icoDarkMode-wolf">
                <Icon icon="menu-burger" />
            </button>
            <Link href="/" className="inline-block leading-none" data-testid="link-home-page">
                {showChristmasPromotion ? (
                    <IconosquareChristmas />
                ) : (
                    <Iconosquare size={24} className="text-icoBlue" />
                )}
            </Link>
            <SideBar isMenuOpen={isOpen} toggleMenu={toggle} />
        </div>
    );
}
